import React, { Fragment, useRef, useState } from "react";
import styles from "./ContactSection.module.css";
import Button from "../UI/Button";

const ContactSection = () => {
  const nameRef = useRef();
  const emailRef = useRef();
  const messageRef = useRef();
  const sendEmailHandler = () => {
    window.Email.send({
      SecureToken: "ef20b99f-38eb-44af-a5a6-1a28d06e00c0",
      To: "mohamedmagdy7428@gmail.com",
      From: "mohamedtest965@gmail.com",
      Subject: "Form Message",
      Body: `<h1>Name: ${nameRef.current.value}</h1><h3>Email: ${emailRef.current.value}</h3><p>Message: ${messageRef.current.value}</p> `,
    }).then((message) => {
      if (message === "OK") {
        alert("Your message sent successfully. Thanks!");
        nameRef.current.value = "";
        emailRef.current.value = "";
        messageRef.current.value = "";
      } else {
        alert(message);
      }
    });
  };

  return (
    <Fragment>
      <section className={styles.sec} id="contact">
        <h2>
          <span>Contact</span>
        </h2>
        <div className={styles.container}>
          <ul className={styles.iconContainer}>
            <li>
              <ion-icon name="mail-outline"></ion-icon>{" "}
              <p>mohamedmagdy7428@gmail.com</p>
            </li>
            <li>
              <ion-icon name="location-outline"></ion-icon>
              <p>Alexandria, Egypt</p>
            </li>
            <li>
              <ion-icon name="phone-portrait-outline"></ion-icon>
              <p>+20 111-742-8107</p>
            </li>
            <li>
              <Button
                className={styles.btnResume}
                color="red"
                target="_blank"
                href="https://drive.google.com/file/d/1jy0f_Wy7eO2HS3A5d25mbuF-zwpb-Yq-/view?usp=drive_link"
              >
                Download resume
              </Button>
            </li>
          </ul>
          <div className={styles.formContainer}>
            <form name="contact" method="post">
              <h3>SAY SOMETHING</h3>
              <input
                type="text"
                placeholder="Your Name..."
                name="name"
                ref={nameRef}
              />
              <input
                type="email"
                placeholder="Your Email..."
                name="email"
                ref={emailRef}
              />
              <textarea
                placeholder="Message..."
                name="message"
                ref={messageRef}
              ></textarea>
              <button type="button" onClick={sendEmailHandler}>
                SEND
              </button>
            </form>
          </div>
        </div>
      </section>
      <footer>
        <div className={styles.social}>
          <a
            href="https://www.linkedin.com/in/mohamed-magdy-57058321b/"
            className={styles.social}
            target="_blank"
            rel="noreferrer"
          >
            <ion-icon name="logo-linkedin"></ion-icon>
          </a>
          <a
            href="https://github.com/Mohamed1442"
            className={styles.social}
            target="_blank"
            rel="noreferrer"
          >
            <ion-icon name="logo-github"></ion-icon>
          </a>
        </div>
        <div className={styles.icon}>
          <a href="#" className={styles.icon}>
            <ion-icon name="arrow-up-outline"></ion-icon>
          </a>
        </div>
        <p className={styles.cr}>
          Copyright © 2022, Mohamed Magdy.All Rights Reserved
        </p>
      </footer>
    </Fragment>
  );
};

export default ContactSection;
